import invitation_border1 from "../images/birthday/birthday_invitation_border1.png";
import birthdaycake1 from "../images/birthday/birthdaycake1.png";
import '../invitations/Invitation.css'

const birthdayInvitationElements = [
{
id:1,
type:"image",
src:invitation_border1,
x:50,
y:480,
width:200,
height:300
},
{
id:3,
type:"text",
text:"🎉 Birthday Invitation 🎉",
x:50,
y:70,
fontSize:45,
fontFamily:"EB Garamond",
fill:"#060339"
},
{
id:4,
type:"text",
text:"Join us to celebrate the special day of",
x:20,
y:230,
fontSize:35,
fontFamily:"Tangerine",
fill:"#060339"
},
{
id:5,
type:"text",
text:"Aarav's 7th Birthday",
x:120,
y:270,
fontSize:30,
fontFamily:"Tangerine",
fill:"#060339"
},
{
id:6,
type:"text",
text:"We invite you to join the fun and celebration!",
x:30,
y:350,
fontSize:30,
fontFamily:"Tangerine",
fill:"#060339"
},
{
id:7,
type:"text",
text:"🎉 Birthday Party 📅 Sunday, 15/03/2026 ⏰ 06:00 pm",
x:0,
y:420,
fontSize:25,
fontFamily:"Tangerine",
fill:"#060339"
},
{
id:8,
type:"text",
text:"📍 Venue:",
x:280,
y:500,
fontSize:22,
fontFamily:"Vollkorn",
fill:"#060339"
},
{
id:9,
type:"text",
text:"ABC PARTY HALL",
x:280,
y:530,
fontSize:20,
fontFamily:"Vollkorn",
fill:"#060339"
},
{
id:10,
type:"text",
text:"City / Address",
x:280,
y:560,
fontSize:20,
fontFamily:"Vollkorn",
fill:"#060339"
},
{
id:11,
type:"text",
text:"Your presence will make the celebration",
x:250,
y:620,
fontSize:18,
fontFamily:"Dancing Script",
fill:"#060339"
},
{
id:12,
type:"text",
text:"even more joyful and memorable.",
x:270,
y:650,
fontSize:18,
fontFamily:"Dancing Script",
fill:"#060339"
},
{
id:13,
type:"text",
text:"Hosted by",
x:330,
y:700,
fontSize:18,
fontFamily:"Merriweather",
fill:"#060339"
},
{
id:14,
type:"text",
text:"Aarav's Family",
x:330,
y:730,
fontSize:18,
fontFamily:"Merriweather",
fill:"#060339"
},
{
id:15,
type:"text",
text:"📞 648200xxxx",
x:330,
y:750,
fontSize:18,
fontFamily:"Merriweather",
fill:"#060339"
},
{
id:16,
type:"image",
src:birthdaycake1,
x:340,
y:150,
width:290,
height:270
}
];

export default birthdayInvitationElements;